import React from "react";
import { Link } from "react-router-dom";
import GraphicStorageConst from "../graphic-storage-const";


const GraphicStorageViewField = ({ id, count, model }) => {
    return (
        <div className='view-box-field' style={{ marginLeft: '24px' }}>
            { count ?
                <Link
                    to={ `${ GraphicStorageConst.basePath }/${ id }/${ model }` }
                >
                    <span className='count'>{ count }</span>
                    <span className='btn-view'>view</span>
                </Link> : <strong>&mdash;</strong> }
        </div>

    );
};

export default GraphicStorageViewField;

